import '@styles/pages/cgu.scss';

import { initAnchor } from '@molecules/anchor';

initAnchor();
